import {BaseMapData} from './BaseMapData.ts'
import {LobbyImage, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum} from '@colonist/types'
import {StoreMapType} from '../entity_datas/StoreEnums.ts'
import {type TranslationObject} from '@colonist/i18n'

export class MapDataEarth extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Earth]
    mapEnum = MapSettingEnum.Earth
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.earth.title'}
    image = LobbyImage.MapEarthPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 81

    scenario = ScenarioSettingEnum.None
}

export class MapDataEarthSeafarers extends MapDataEarth {
    mapEnum = MapSettingEnum.EarthSeafarers
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    numberOfLandTiles = 81

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataUSA extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.USA]
    mapEnum = MapSettingEnum.USA
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.usa.title'}
    image = LobbyImage.MapUSAPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 144

    scenario = ScenarioSettingEnum.None
}

export class MapDataUK extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.UK]
    mapEnum = MapSettingEnum.UK
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.uk.title'}
    image = LobbyImage.MapUKPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 63

    scenario = ScenarioSettingEnum.None
}

export class MapDataUKSeafarers extends MapDataUK {
    mapEnum = MapSettingEnum.UKSeafarers
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    numberOfLandTiles = 63

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataDiamond extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Diamond]
    mapEnum = MapSettingEnum.Diamond
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.diamond.title'}
    image = LobbyImage.MapDiamondPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 24

    scenario = ScenarioSettingEnum.None
}

export class MapDataGear extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Gear]
    mapEnum = MapSettingEnum.Gear
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.gear.title'}
    image = LobbyImage.MapGearPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 43

    scenario = ScenarioSettingEnum.None
}

export class MapDataLakes extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Lakes]
    mapEnum = MapSettingEnum.Lakes
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.lakes.title'}
    image = LobbyImage.MapLakesPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 39

    scenario = ScenarioSettingEnum.None
}

export class MapDataPond extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Pond]
    mapEnum = MapSettingEnum.Pond
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.pond.title'}
    image = LobbyImage.MapPondPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 24

    scenario = ScenarioSettingEnum.None
}

export class MapDataTwirl extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Twirl]
    mapEnum = MapSettingEnum.Twirl
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.twirl.title'}
    image = LobbyImage.MapTwirlPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 42

    scenario = ScenarioSettingEnum.None
}

export class MapDataShuffleBoard extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.ShuffleBoard]
    mapEnum = MapSettingEnum.ShuffleBoard
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.shuffleBoard.title'}
    image = LobbyImage.MapShuffleBoardPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 25

    scenario = ScenarioSettingEnum.None
}

export class MapDataBlackForest extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.BlackForest]
    mapEnum = MapSettingEnum.BlackForest
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.blackForest.title'}
    image = LobbyImage.MapBlackForestPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 55

    scenario = ScenarioSettingEnum.None
}

export class MapDataVolcano extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Volcano]
    mapEnum = MapSettingEnum.Volcano
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.volcano.title'}
    image = LobbyImage.MapVolcanoPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 71

    scenario = ScenarioSettingEnum.None
}

export class MapDataGoldRush extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.GoldRush]
    mapEnum = MapSettingEnum.GoldRush
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.goldRush.title'}
    image = LobbyImage.MapGoldRushPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = true
    isActive = true
    numberOfLandTiles = 31

    scenario = ScenarioSettingEnum.None
}

export class MapDataVietnam extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Vietnam
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.vietnam.title'}
    image = LobbyImage.MapVietnamPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 98

    scenario = ScenarioSettingEnum.None
}

export class MapDataJellyFish extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.JellyFish
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.jellyFish.title'}
    image = LobbyImage.MapJellyFishPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 30

    scenario = ScenarioSettingEnum.None
}

export class MapDataCircle extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Circle
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.circle.title'}
    image = LobbyImage.MapCirclePreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 30

    scenario = ScenarioSettingEnum.None
}

export class MapDataKite extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Kite
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.kite.title'}
    image = LobbyImage.MapKitePreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 31

    scenario = ScenarioSettingEnum.None
}

export class MapDataDuel extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Duel
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.duel.title'}
    image = LobbyImage.MapDuelPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 11

    scenario = ScenarioSettingEnum.None
}

export class MapDataMiniBase extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.MiniBase
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.miniBase.title'}
    image = LobbyImage.MapMiniBasePreview
    compatibleGameModes = [ModeSettingEnum.Classic4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 14

    scenario = ScenarioSettingEnum.None
}

export class MapDataKingOfTheHill extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.KingOfTheHill
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.kingOfTheHill.title'}
    image = LobbyImage.MapKingOfTheHillPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P]
    includeInFreeMapRotationIfActive = false
    // this map is broken and should never be enabled
    isActive = false
    numberOfLandTiles = 26

    scenario = ScenarioSettingEnum.None
}

export class MapDataMountainOfRiches extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.MountainOfRiches
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.mountainOfRiches.title'}
    image = LobbyImage.MapMountainOfRichesPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.CitiesAndKnights4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 24

    scenario = ScenarioSettingEnum.None
}

export class MapDataTwoIsles extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TwoIsles
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.twoIsles.title'}
    image = LobbyImage.MapTwoIslesPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 25

    scenario = ScenarioSettingEnum.None
}

export class MapDataDoggo extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Doggo
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.doggo.title'}
    image = LobbyImage.MapDoggoPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 46

    scenario = ScenarioSettingEnum.None
}

export class MapDataTradeIslands extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TradeIslands
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.tradeIslands.title'}
    image = LobbyImage.MapTradeIslandsPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P]
    includeInFreeMapRotationIfActive = false
    // this map is broken and should never be enabled
    isActive = false
    numberOfLandTiles = 27

    scenario = ScenarioSettingEnum.None
}

export class MapDataTradeIslandSeafarers extends MapDataTradeIslands {
    mapEnum = MapSettingEnum.TradeIslandsSeafarers
    compatibleGameModes = [ModeSettingEnum.Seafarers4P]
    includeInFreeMapRotationIfActive = false
    numberOfLandTiles = 27

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataTurningTidesClassic extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TurningTidesClassic
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.turningTidesClassic.title'}
    image = LobbyImage.MapTurningTidesPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 77

    scenario = ScenarioSettingEnum.None
}

export class MapDataTurningTidesSeafarers extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TurningTidesSeafarers
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.turningTidesSeafarers.title'}
    image = LobbyImage.MapTurningTidesPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 54

    scenario = ScenarioSettingEnum.SS4ThroughTheDesert
}

export class MapDataRomania extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Romania
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.romania.title'}
    image = LobbyImage.MapRomaniaPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 56

    scenario = ScenarioSettingEnum.None
}

export class MapDataMonopoly extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Monopoly
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.monopoly.title'}
    image = LobbyImage.MapMonopolyPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 19

    scenario = ScenarioSettingEnum.None
}

export class MapDataIstanbul extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Istanbul
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.istanbul.title'}
    image = LobbyImage.MapIstanbulPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 45

    scenario = ScenarioSettingEnum.None
}

export class MapDataIstanbulSeafareres extends MapDataIstanbul {
    mapEnum = MapSettingEnum.IstanbulSeafarers
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    numberOfLandTiles = 45

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataEurope extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Europe
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.europe.title'}
    image = LobbyImage.MapEuropePreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 96

    scenario = ScenarioSettingEnum.None
}

export class MapDataEuropeSeafarers extends MapDataEurope {
    mapEnum = MapSettingEnum.EuropeSeafarers
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    numberOfLandTiles = 96

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataStripes extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Stripes
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.stripes.title'}
    image = LobbyImage.MapStripesPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.CitiesAndKnights4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 20

    scenario = ScenarioSettingEnum.None
}

export class MapDataMonopolyIslands extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.MonopolyIslands
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.fun.monopolyIslands.title'}
    image = LobbyImage.MapMonopolyIslandsPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 49

    scenario = ScenarioSettingEnum.None
}

export class MapDataMonopolyIslandsSeafarers extends MapDataMonopolyIslands {
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P]
    mapEnum = MapSettingEnum.MonopolyIslandsSeafarers
    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
    isActive = false
    numberOfLandTiles = 43
}
